var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15 20.462-6-2.1-4.304 1.665a.82.82 0 0 1-.819-.098.86.86 0 0 1-.377-.737V6.077a.93.93 0 0 1 .159-.532.9.9 0 0 1 .445-.341L9 3.539l6 2.1 4.304-1.666a.84.84 0 0 1 .819.084q.377.255.377.712v13.193a.87.87 0 0 1-.173.536 1 1 0 0 1-.47.336zm-.75-1.835v-11.7l-4.5-1.573v11.7zm1.5 0L19 17.55V5.7l-3.25 1.227zM5 18.3l3.25-1.246v-11.7L5 6.45z"
  })));
};
export default SvgMap;